import { addDays } from 'date-fns';
import type { SettingsWeek } from '../settings-week/settings-week';
import { formatRegularDay } from './format-regular-day';
import type { RegularWeek } from './regular-week';

export function getWeekFromDate(
  settingsWeek: SettingsWeek,
  givenDate: Date = new Date()
): RegularWeek {
  const todayWeekdayIndex = givenDate.getDay();

  const weekFromGivenDate = [
    ...settingsWeek.slice(todayWeekdayIndex),
    ...settingsWeek.slice(0, todayWeekdayIndex)
  ];

  return weekFromGivenDate.map((day, index) => {
    const date = addDays(givenDate, index);
    return formatRegularDay(day, date, givenDate, true);
  });
}
